import React, { useState } from "react";
import { Link } from "react-router-dom";

// CSS
import "./header.css";

// Icon
import { FaCartShopping } from "react-icons/fa6";
import { FaPhoneAlt, FaBars, FaTimes } from "react-icons/fa";

// Components
import CompanyLogo from "../CompanyLogo/CompanyLogo";
import { useShowMango } from "../../hooks/useShowMango";

const BASE_NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/menu", label: "Menu" },
  { to: "/custom", label: "Custom Platters" },
];
const MANGO_LINK = { to: "/mango", label: "🥭 Mango", className: "text-secondary font-bold" };

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const showMango = useShowMango();
  const NAV_LINKS = showMango ? [...BASE_NAV_LINKS, MANGO_LINK] : BASE_NAV_LINKS;

  return (
    <header className="header">
      <div className="header-container">
        <CompanyLogo />

        {/* Inline nav - only shown at lg+, where it fits on one row */}
        <nav className="nav">
          <ul className="nav-links">
            {NAV_LINKS.map((link) => (
              <li key={link.to} className="nav-link">
                <Link to={link.to} className={link.className}>
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="header-actions">
          <a href="tel:+8801521494760" className="nav-cta btn btn-primary">
            <FaPhoneAlt className="nav-phone-icon" />
          </a>
          <Link className="nav-cta btn btn-secondary" to="/order">
            <FaCartShopping className="nav-cart-icon" />
          </Link>
          <button
            type="button"
            className="nav-toggle"
            onClick={() => setMenuOpen((open) => !open)}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {/* Collapsible nav - only rendered below lg, keeps the header itself
          a fixed, predictable single-row height at every breakpoint
          instead of letting nav-links wrap inside it. */}
      {menuOpen && (
        <nav className="nav-mobile">
          <ul className="nav-mobile-links">
            {NAV_LINKS.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className={link.className}
                  onClick={() => setMenuOpen(false)}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </header>
  );
};

export default Header;
